import React, { Suspense } from "react";

export const ImageBackground = ({ image, classes }) => {
  return (
    <div className="image-background">
      <Suspense>
        <img
          src={image}
          width={1200}
          alt="this is a background"
          className={"background " + classes}
          style={{ width: "100%" }}
        />
      </Suspense>
    </div>
  );
};
